// extracted by mini-css-extract-plugin
export default {"errorsList":"errors-list--KiS0af4J66h_PaZnXa93"};